// extracted by mini-css-extract-plugin
module.exports = {"h2":"_404-module--h2--7sy5V","center":"_404-module--center--2bpK7","lines":"_404-module--lines--1LHJy"};